module.exports = __webpack_public_path__ + "img/hys-7.b20d998a.jpg";